<template>
    <div class="grafica-avance-estimaciones">
      <!-- MENSAJE PARA NO MOSTRAR GRÁFICA PORQUE LOS IMPORTES NO COINCIDEN -->
      <v-alert
        v-if="!mostrarGrafica"
        type="warning"
        :icon="false"
        class="mt-3">
          <v-card color="warning"
            v-if="!mostrarGrafica"
            flat>
              <v-card-title>Favor de revisar</v-card-title>
              <v-card-text>
                <span v-if="!contrato.esObraFinanciada">
                El Importe de Contrato+Convenios
                </span>
                <span v-if="contrato.esObraFinanciada">
                El Importe de Costo Directo de Contrato+Convenios
                </span>
                <v-chip class="text-subtitle-2">
                  {{sumaContratoConveniosCostoDirecto | currency}}</v-chip>
                no coincide con el Total
                del Programa de Obra
                <v-chip class="text-subtitle-2">
                  {{totalImporteProgramaCostoDirecto | currency}}</v-chip>
            </v-card-text>
          </v-card>
        </v-alert>

        <v-container
        fluid>
            <!-- CARD DE GRAFICAS -->
            <v-card
            v-if="mostrarGrafica"
            flat
            >
            <!-- GRAFICA AVANCE FINANCIERO-->
                <v-card-title primary-title class="justify-center">
                    Avance Financiero ($)</v-card-title>
                <v-card-text >
                    <line-chart
                    :width="widthGrafica"
                    :height="heightGrafica"
                    align="center"
                    :chart-data="dataGrafica"
                    :options="optionsGrafica"
                    >
                    </line-chart>
                <v-divider class="pa-5"></v-divider>
                <!-- TABLA DE DATOS -->
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                    <tr>
                        <th
                            v-for="item in mixCalcularPuntosGrafica.puntosLetra"
                            :key="item">{{ item }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td
                            v-for="(item,index) in mixCalcularPuntosGrafica.programado"
                            :key="index">
                            <v-chip
                            v-if="item===0"
                            class="azul2 pr-5">PROG</v-chip>
                            <span v-if="item!==0">{{ item | currency }}</span></td></tr>
                        <tr>
                        <td
                            v-for="(item,index) in mixCalcularPuntosGrafica.financieroTabla"
                            :key="index">
                            <v-chip
                            v-if="item==='-'"
                            class="error pr-5">REAL</v-chip>
                            <span v-if="item!=='-'">{{ item | currency }}</span></td></tr>
                    </tbody>
                    </template>
                </v-simple-table>
                </v-card-text>

                <!-- GRAFICA AVANCE PORCENTAJE-->
                <v-card-title primary-title class="justify-center mt-10">
                    Avance Físico (%)</v-card-title>
                <v-card-text>
                    <line-chart
                    :width="widthGrafica"
                    :height="heightGrafica"
                    align="center"
                    :chart-data="dataGraficaPorcentajes"
                    :options="optionsGrafica"
                    >
                    </line-chart>
                    <v-divider class="pa-5"></v-divider>
                    <!-- TABLA DE DATOS PORCENTAJE-->
                    <v-simple-table>
                    <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-center"
                            v-for="item in mixCalcularPuntosGrafica.puntosLetra"
                            :key="item">{{ item }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td class="text-center"
                            v-for="(item,index) in mixCalcularPuntosGrafica.programadoPorcentaje"
                            :key="index">
                            <v-chip
                            v-if="item===0"
                            class="azul2 pr-5">PROG</v-chip>
                            <span
                            v-if="item!==0">{{ item }}%</span>
                            </td></tr>
                        <tr>
                        <td class="text-center"
                          v-for="(item,index) in mixCalcularPuntosGrafica.financieroPorcentajeTabla"
                            :key="index">
                            <v-chip
                            v-if="item==='-'"
                            class="error pr-5">REAL</v-chip>
                            <span
                            v-if="item!=='-'">{{ item }}%</span></td></tr>
                    </tbody>
                    </template>
                </v-simple-table>

                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import CONTRATO_CONVENIOS_MODIFICATORIOS from '@/graphql/querys/administracion/contratos/contrato/convenios.gql';
import LineChart from '@/components/charts/LineChart';
import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramadoCostoDirecto';
import mixAvanceFinanciero from '@/helpers/calculos/mixAvanceFinancieroCostoDirecto';
import mixGraficaAvanceEstimaciones from '@/components/administracion/ejecucion/estimaciones/reportes/mixGraficaAvanceEstimaciones';

export default {
  name: 'GraficaAvanceEstimaciones',
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    contratoEstimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    programasobra: {
      type: Array,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  components: {
    LineChart,
  },
  mixins: [mixAvanceProgramado, mixAvanceFinanciero, mixGraficaAvanceEstimaciones],
  data() {
    return {
      widthGrafica: 1080,
      heightGrafica: 500,
      optionsGrafica: {
        responsive: false,
        maintainAspectRatio: false,
      },
      // dataGrafica: {},
      // dataGraficaPorcentajes: {},
      meses: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago',
        'Sep', 'Oct', 'Nov', 'Dic',
      ],
    };
  },
  apollo: {
    contratoConveniosModificatorios: {
      query: CONTRATO_CONVENIOS_MODIFICATORIOS,
      variables() {
        return {
          idContrato: this.contrato.id,
        };
      },
    },
  },
  /*
  mounted() {
    this.getDataGraficas();
  },

  watch: {
    estimacion() {
      this.getDataGraficas();
    },
  },
  */
  computed: {
    getImporteContrato() {
      if (this.contrato.esObraFinanciada) {
        return this.contrato.importeCostoDirecto;
      }

      return this.contrato.importe;
    },
    getContratoConveniosModificatorios() {
      const fechaAl = this.estimacion.fechaAl || '';
      if (!this.contratoConveniosModificatorios || fechaAl === '') return [];

      // Retorna convenios modificatorios anteriores o iguales a la fechaAl de la estimación
      return this.contratoConveniosModificatorios
        .filter(({ fecha }) => new Date(`${fecha} 00:00:00`) <= new Date(`${fechaAl} 00:00:00`));
    },
    mostrarGrafica() {
      return true;
      // Solo se muestra la gráfica cuando el importe del contrato más el costo directo de los
      // convenios modificatorios es igual al importe a costo directo del programa
      // if (this.totalImporteProgramaCostoDirecto === this.sumaContratoConveniosCostoDirecto) {
      //   this.$emit('mostrarGrafica');
      //   return true;
      // }
      // return false;
    },
    totalImporteProgramaCostoDirecto() {
      let programaObra = [];
      // Si no existe programa de obra de la estimación ni del contrato, asigna array vacío
      if (!this.estimacion.programa && !this.contratoProgramasObra) programaObra = [];
      if (!this.contratoProgramasObra) programaObra = [];
      else {
        // Si existe programa de obra del contrato, lo asigna
        const [{ programa }] = this.contratoProgramasObra;
        programaObra = programa;
      }

      // Si existe el progrma de obras de la estimación, lo reasigna
      if (this.estimacion.programa.length >= 1) {
        programaObra = this.estimacion.programa;
      }

      // Retorna el total del monto del programa de obra asignado
      return this.$numberRoundDigits(programaObra
        .map((item) => item.monto).reduce((a, b) => a + b, 0), 2);
    },
    sumaContratoConveniosCostoDirecto() {
      const sumarConvenios = this.$ObjSumar(this.getContratoConveniosModificatorios, 'importe');
      const sumarConveniosCostoDirecto = this.$ObjSumar(this.getContratoConveniosModificatorios, 'importeCostoDirecto');

      if (this.contrato.esObraFinanciada) {
        return Math.round((this.getImporteContrato + sumarConveniosCostoDirecto) * 100) / 100;
      }

      return Math.round((this.getImporteContrato + sumarConvenios) * 100) / 100;
    },
    dataGrafica() {
      return {
        labels: [...this.mixCalcularPuntosGrafica.puntosLetra],
        datasets: [
          {
            label: 'PROGRAMADO',
            fill: false,
            data: [...this.mixCalcularPuntosGrafica.programado],
            borderColor: '#6A83B5',
            tension: 0.1,
          },
          {
            label: 'REAL',
            fill: false,
            data: [...this.mixCalcularPuntosGrafica.financiero],
            borderColor: '#FA8B00',
            tension: 0.1,
          },
        ],
      };
    },
    dataGraficaPorcentajes() {
      return {
        labels: [...this.mixCalcularPuntosGrafica.puntosLetra],
        datasets: [
          {
            label: 'PROGRAMADO',
            fill: false,
            data: [...this.mixCalcularPuntosGrafica.programadoPorcentaje],
            borderColor: '#6A83B5',
            tension: 0.1,
          },
          {
            label: 'REAL',
            fill: false,
            data: [...this.mixCalcularPuntosGrafica.financieroPorcentaje],
            borderColor: '#FA8B00',
            tension: 0.1,
          },
        ],
      };
    },
  },
  methods: {
    /*
    getDataGraficas() {
      this.dataGrafica = {
        labels: [...this.mixCalcularPuntosGrafica.puntosLetra],
        datasets: [
          {
            label: 'PROGRAMADO',
            fill: false,
            data: [...this.mixCalcularPuntosGrafica.programado],
            borderColor: '#6A83B5',
            tension: 0.1,
          },
          {
            label: 'REAL',
            fill: false,
            data: [...this.mixCalcularPuntosGrafica.financiero],
            borderColor: '#FA8B00',
            tension: 0.1,
          },
        ],
      };
      this.dataGraficaPorcentajes = {
        labels: [...this.mixCalcularPuntosGrafica.puntosLetra],
        datasets: [
          {
            label: 'PROGRAMADO',
            fill: false,
            data: [...this.mixCalcularPuntosGrafica.programadoPorcentaje],
            borderColor: '#6A83B5',
            tension: 0.1,
          },
          {
            label: 'REAL',
            fill: false,
            data: [...this.mixCalcularPuntosGrafica.financieroPorcentaje],
            borderColor: '#FA8B00',
            tension: 0.1,
          },
        ],
      };

    }, */
  },

};
</script>
<style lang="scss" scoped>
#line-chart {
  height:600px !important;
}
</style>
